import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_authenticated/development/real-estate/')({
  component: RealEstateIndex,
})

function RealEstateIndex() {
  const navigate = Route.useNavigate()

  useEffect(() => {
    navigate({
      to: '/development/real-estate/$tab',
      params: { tab: 'map' },
      replace: true,
      search: (prev) => ({ ...prev }),
    })
  }, [navigate])

  return null
}
